<template>
    <div>
        <v-layout wrap justify-center align-center>
            <v-flex md7 sm7 xs12>
                <dialogos-app :dialogos="dialogos" tucan="0"></dialogos-app>
            </v-flex>
        </v-layout>
        <v-layout wrap row justify-center align-center text-xs-center class="cont_page">
          <v-flex class="cont-img animated fadeInUp dura-2" md10 xs11>
              <v-card color="transparent" flat tile>

                  <v-window v-model="onboarding">
                    <v-window-item  v-for="n in length" :key="`card-${n}`">
                      <v-card class="cont_text-slider" color="transparent" flat>
                        <img :src="require('@/assets/unidad1/slide-9/slide-9-'+(onboarding+1)+'.jpg')" alt="">
                        <h2>{{titulo[onboarding]}}</h2>
                        <p v-html="textos[onboarding]"></p>
                      </v-card>
                    </v-window-item>
                  </v-window>

                  <v-card-actions class="cont_buttons-slider">
                    <v-item-group light v-model="onboarding" class="text-center " mandatory>
                      <v-item v-for="n in length" :key="`btn-${n}`" v-slot:default="{ active, toggle }">
                        <v-btn :color="active ? '#3C9043' : '#D3D2D2'" small class="item-button" :input-value="active" icon @click="toggle">
                          <v-icon >mdi-record</v-icon>
                        </v-btn>
                      </v-item>
                    </v-item-group>
                  </v-card-actions>

              </v-card>
          </v-flex>
        </v-layout>
        <audio-player ref="audioPlayer" :autoplay="true" :audios="['slide9/urubu','slide9/Barco','slide9/Farol']"></audio-player>
    </div>
</template>
<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
  mixins: [nextConditions],
  data() {
    return {
      currentText: 0,
      dialogos: [
        'Em português, existem várias letras com som de [u].',
        'Depois de ler os seguintes itens, clique em avançar para fazer a atividade:'    
      ],
      textos:[
        'Caso 1. A vogal U (ou US) sempre será pronunciada como [u] (ou [us]).',
        'Caso 2. Quando a vogal O (ou OS) estiver no final das palavras, será pronunciada como [u] (ou [us]). No entanto, se essa vogal for acentuada, a pronúncia será [o].',
        'Caso 3. A letra L no final das sílabas ou no final das palavras é pronunciada como [u].'
      ],
      titulo:[
        'Urubu', //cambiar imagen por Urubu (chulo)
        'Barco',
        'Farol',
      ],
      length: 3,
      onboarding: 0,
      valueLetra:0,
      btnVistoA:Array(9).fill(false),

    }
  },
  methods: {
    mostrarLetraA(val){

    }
  },
  watch: {
     onboarding(){
      if(this.onboarding == 0){
        this.$refs.audioPlayer.playAudio((0))
      }
      if(this.onboarding == 1){
        this.$refs.audioPlayer.playAudio((1))
      }
      if(this.onboarding == 2){
        this.$refs.audioPlayer.playAudio((2))
        this.$store.commit('nextShow', true);
      }}
  },
}
</script>
<style lang="scss" scoped>
// NOT SCOPED !!
@import '../../sass/globals';
.cont_text-slider{
  height: auto;
  img{
    height: 150px;
  }
  p{
    font-family: Poppins-Regular;
    font-size: 12px;
  }
  h2{
    font-family: Poppins-Regular;
    font-size: 16px;
  }
}
.cont_buttons-slider{
  justify-content: center;
  .item-button{
    width: 20px;
    height: 20px;
  }
}
.cont-letras{
  .letra-button{
    border: solid $ibra-dark-blue;
    width: 53px;
    height: 53px;
    margin: 8px;
    border-radius: 10px;
    .t-blue{
      color: $ibra-dark-blue;
      font-family:Poppins-Regular;
      font-size: 35px;
      margin: 0;
      padding: 0;
      line-height: 0;
    }
  }
}
.active{
  background: $ibra-dark-blue;
  .t-blue{
    color: white!important;
  }
}

.t-first{
   font-family:Poppins-BoldItalic;
   font-size: 20px;
}

.img-letra{
  img{
    width: 200px;
    @media screen and (min-width: 900px) {
      width: 400px;
    }
  }
}
.cont-letras-textos{
    p{
      margin: 0;
      padding: 0;
      font-family:Poppins-Bold;
      font-size: 13px;
      padding: 5px;
    }
}

</style>
